import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import _ from 'lodash';
import {
  VictoryChart, VictoryTheme, VictoryBar, VictoryAxis, VictoryLabel,
} from 'victory';
import {
  Paper, Typography, Select, MenuItem,
} from '@material-ui/core';
import { scaleLinear } from 'd3-scale';
import Measure from 'react-measure';

const polylinearScale = scaleLinear()
  .domain([0, 20, 500, 1000])
  .range([0, 10, 70, 100]);

const roundTo2Decimal = value => Math.round(value * 100) / 100;

class BarGraph extends React.Component {
  static propTypes = {
    config: PropTypes.object,
    graphHeight: PropTypes.number,
  };

  static defaultProps = {
    config: {},
    graphHeight: 400,
  };

  constructor(props) {
    super(props);

    this.state = {
      selectedOption: props.config.options ? props.config.options[0].value : 'OVERALL',
    };
  }

  render() {
    const {
      title, legends, options, data,
    } = this.props.config;

    const graphData = data[this.state.selectedOption]
      ? Object.keys(data[this.state.selectedOption]).map((key) => {
        const keyValue = data[this.state.selectedOption][key];
        const { label } = _.filter(legends, { value: key })[0];

        return {
          x: label,
          y: polylinearScale(keyValue),
          value: keyValue,
        };
      })
      : [];

    return (
      <StyledPaper elevation={1}>
        <Header>
          <Typography variant="title">{title || ''}</Typography>

          {options && (
            <StyledSelect
              value={this.state.selectedOption}
              onChange={(event) => {
                this.setState({
                  selectedOption: event.target.value,
                });
              }}
              inputProps={{
                name: title || Date.now(),
                id: title || Date.now(),
              }}
              autoWidth
            >
              {options
                && options.map(choice => (
                  <MenuItem key={choice.value} value={choice.value}>
                    {choice.label}
                  </MenuItem>
                ))}
            </StyledSelect>
          )}
        </Header>
        <Measure bounds>
          {({ measureRef, contentRect }) => {
            const {
              bounds: { width },
            } = contentRect;
            const padding = {
              top: 20,
              bottom: 20,
              left: 20,
              right: 20,
            };
            const graphWidth = width - padding.left - padding.right;
            return (
              <ChartContainer innerRef={measureRef}>
                {!_.isNaN(graphWidth) && (
                  <VictoryChart
                    width={graphWidth}
                    height={this.props.graphHeight}
                    domainPadding={60}
                    theme={VictoryTheme.material}
                  >
                    <VictoryAxis
                      style={{ axisLabel: { fontSize: 16, padding: 35 } }}
                      tickLabelComponent={
                        <VictoryLabel angle={legends.length > 6 ? -10 : 0} dy={15} />
                      }
                    />
                    <VictoryAxis
                      style={{
                        tickLabels: { fill: 'transparent' },
                      }}
                      dependentAxis
                    />
                    <VictoryBar
                      animate={{
                        duration: 500,
                      }}
                      standalone={false}
                      data={graphData}
                      labels={d => roundTo2Decimal(d.value)}
                      barRatio={0.3}
                    />
                  </VictoryChart>
                )}
              </ChartContainer>
            );
          }}
        </Measure>
      </StyledPaper>
    );
  }
}

export default BarGraph;

const StyledPaper = styled(Paper)`
  padding: 20px;
  position: relative;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const StyledSelect = styled(Select)`
  width: 40%;
`;

const ChartContainer = styled.div`
  padding: 20px;
`;



// WEBPACK FOOTER //
// ./src/components/BarGraph/BarGraph.js